(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSModalidadDetailController', SSModalidadDetailController);

    SSModalidadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSModalidad'];

    function SSModalidadDetailController($scope, $rootScope, $stateParams, previousState, entity, SSModalidad) {
        var vm = this;

        vm.sSModalidad = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSModalidadUpdate', function(event, result) {
            vm.sSModalidad = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
